// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"HomeHighlights_Wrapper__2_XX_"};